var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"text-align":"center","margin-top":"50px"}},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_setup.close}},[_vm._v("关闭")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }